<template>
    <div>
        <div class="card logs">
            <table class="n-table main-table bordered">
                <thead class="header">
                    <th>Fecha/Hora</th>
                    <th>Usuario</th>
                    <th>IP</th>
                    <th>Dispositivo</th>
                    <th>Ruta</th>
                    <th>Parámetros</th>
                </thead>
                <tbody>
                    <template v-if="!groupByGuid">
                        <audit-logs-row
                            v-for="log in logs"
                            :log="log"
                            :key="log"
                        />
                    </template>
                    <template v-else>
                        <audit-logs-group-row
                            v-for="logGroup in logs"
                            :key="logGroup.refererGuid"
                            :group="logGroup"
                        />
                    </template>
                </tbody>
            </table>
        </div>

        <WePagination
            v-show="paginationTotalPages > 1"
            :total="paginationTotalPages"
            v-model="pagination"
        />
    </div>
</template>

<script>
import AuditLogsRow from "@/components/admin/AuditLogsRow.vue";
import AuditLogsGroupRow from "@/components/admin/AuditLogsGroupRow.vue";
import WePagination from "../../lib/WebExperto/components/WePagination.vue";

export default {
    components: {
        AuditLogsRow,
        AuditLogsGroupRow,
        WePagination,
    },
    props: {
        logs: {
            required: true,
        },
        paginationTotalPages: {
            type: Number,
            required: false,
            default: 1,
        },
        groupByGuid: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    methods: {
        resetIndex() {
            this.pagination = 1;
        },
    },
    watch: {
        pagination() {
            if (this.pagination) {
                this.$emit("filter");
            }
        },
    },
    data() {
        return {
            pagination: 1,
        };
    },
};
</script>
